import { Network } from "../../../.."
import store from "../../../../../store"
import { axiosWrapper } from "../../../../axios_old"
import { formatDate, getCurrency } from "../../../../formating"
import { normalizeString } from "../../../../functions"

// ---- Provider Invoices ----
class ADPInvoice {
  constructor(employerInvoice) {
    this.employerInvoice = employerInvoice
    this.sentTs = employerInvoice.sentTs
    this.status = employerInvoice.sentTs ? "Sent" : "Not sent"
    this.paid = ""
  }

  get statusDate() {
    return new Date(this.employerInvoice.createdTs)
  }

  get paymentMethod() {
    return "ADP Invoice"
  }
}

class StripeInvoice {
  constructor(employerInvoice, attributes) {
    this.employerInvoice = employerInvoice
    this.status = attributes.status
    this.status_transitions = attributes.status_transitions
    this.paid = attributes.paid ? "Paid" : ""
    this.effectiveDate = attributes.effectiveDate
  }

  get statusDate() {
    return {
      draft: new Date(this.employerInvoice.createdTs),
      open: new Date(this.employerInvoice.createdTs),
      accepted: this.status_transitions.paid_at || this.status_transitions.finalized_at,
      canceled:
        this.status_transitions.marked_uncollectible_at || this.status_transitions.voided_at
    }[this.status]
  }

  get paymentMethod() {
    return "Credit Card"
  }
}

// ---- EmployerInvoice ----
export default class EmployerInvoice {
  constructor(attributes = {}) {
    Object.assign(this, attributes)

    this.provider = attributes.stripeData
      ? new StripeInvoice(this, attributes.stripeData)
      : new ADPInvoice(this)

    this.tableValues = {
      date: formatDate({
        data: this.effectiveDate || this.createdTs,
        actions: ["display"]
      }),
      description: this.description,
      amount: getCurrency({
        amount: this.quantity ? this.amount * this.quantity : this.amount,
        actions: ["divide"]
      }),
      status: normalizeString({
        data: this.provider.status,
        actions: ["capitalize"]
      }),
      statusDate: formatDate({
        data: this.provider.statusDate,
        actions: ["display+time"],
        defaultReturn: ""
      }),
      paymentMethod: this.provider.paymentMethod
    }
  }

  static async getAll(token, employerId) {
    const {
      data: { data: billingData }
    } = await axiosWrapper(
      "GET",
      `employer/${employerId || "@all"}/billing/invoice`,
      null,
      null,
      token
    )
    return billingData.map((d) => new this(d))
  }

  static async createOne({ user, params, payload }) {
    try {
      await Network.AxiosWrapper({
        method: "POST",
        target: `employer/${params.employerId}/billing/invoice`,
        token: user.token
      })

      await store.setNotification("notification", true, {
        msg: `Successfully charged this employer.`,
        severity: "success",
        isPersist: true
      })
    } catch (err) {
      console.error(err)
    }
  }

  static async rolloverPlan({ user, params, payload }) {
    try {
      await Network.AxiosWrapper({
        method: "POST",
        target: `employer/${params.employerId}/billing/invoice`,
        token: user.token
      })

      await store.setNotification("notification", true, {
        msg: `Successfully charged this employer.`,
        severity: "success",
        isPersist: true
      })
    } catch (err) {
      console.error(err)
    }
  }
}
